var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo, useState } from "react";
import { PeekAutocomplete, PeekInput } from "@piiqtechnologies/ui-components";
import { useError, useLoader, useOrganizations } from "@piiqtechnologies/ui-lib";
export const OrganizationSelector = (_a) => {
    var _b;
    var { field, form } = _a, props = __rest(_a, ["field", "form"]);
    const [getOrganizations, organizations, organizationsLoading, organizationsError] = useOrganizations();
    const { setLoader } = useLoader();
    const { setError } = useError();
    const [searchKey, setSearchKey] = useState();
    useEffect(() => {
        getOrganizations();
    }, []);
    useEffect(() => {
        setLoader(organizationsLoading, "organizationsLoading");
        return () => setLoader(false, "organizationsLoading");
    }, [organizationsLoading]);
    useEffect(() => {
        if (organizationsError) {
            setError(organizationsError.message);
        }
    }, [organizationsError]);
    const options = useMemo(() => {
        var _a;
        if (!(organizations === null || organizations === void 0 ? void 0 : organizations.data))
            return [];
        return (_a = organizations.data) === null || _a === void 0 ? void 0 : _a.filter(({ name }) => !searchKey || name.match(new RegExp(searchKey, "i"))).map(({ _id, name }) => ({ id: _id, name }));
    }, [organizations === null || organizations === void 0 ? void 0 : organizations.data, searchKey]);
    const handleOrganizationSelection = (_event, value) => {
        //@ts-ignore
        form.setFieldValue(field.name, value.id);
    };
    if (!((_b = organizations === null || organizations === void 0 ? void 0 : organizations.data) === null || _b === void 0 ? void 0 : _b.length))
        return null;
    return (React.createElement(PeekAutocomplete, { freeSolo: false, clearIcon: null, popupIcon: null, onChange: handleOrganizationSelection, options: (options === null || options === void 0 ? void 0 : options.length) ? options : [], getOptionLabel: ({ name }) => name, sx: { ".MuiAutocomplete-input": { pl: "4px !important" } }, value: options.find((option) => option.id === field.value), isOptionEqualToValue: (option, value) => option.id === value, renderInput: (params) => (React.createElement(PeekInput, Object.assign({ field: Object.assign(Object.assign({}, field), { value: searchKey, onChange: (e) => setSearchKey(e.target.value) }), form: form }, params, props, { InputLabelProps: { required: true }, InputProps: Object.assign({}, params.InputProps) }))) }));
};
export default OrganizationSelector;
